import { Card, Empty, Typography } from "antd";
import { useRef } from "react";

import type { BuildingItem } from "./BuildingSearchResults";
import { BuildingSearchResults } from "./BuildingSearchResults";
import { DeleteRegistrationPanel } from "./DeleteRegistrationPanel";

const { Text } = Typography;

interface EazyRegistrationDeleteContentProps {
  hasSearched: boolean;
  searchResults: BuildingItem[];
  selectedTarget: BuildingItem | null;
  onSelectedTargetChange: (target: BuildingItem | null) => void;
  onSearchResultsChange?: (results: BuildingItem[]) => void;
  onRefresh?: () => void;
  onLoadMore?: () => Promise<void>;
  loadingMore?: boolean;
}

export const EazyRegistrationDeleteContent = ({
  hasSearched,
  searchResults,
  selectedTarget,
  onSelectedTargetChange,
  onSearchResultsChange,
  onRefresh,
  onLoadMore,
  loadingMore = false,
}: EazyRegistrationDeleteContentProps) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const handleBuildingClick = (item: BuildingItem) => {
    onSelectedTargetChange(item);
  };

  return (
    <div className="flex h-full min-h-0 w-full gap-6">
      <Card
        className="flex h-full min-h-0 flex-1 flex-col"
        styles={{
          header: {
            borderBottom: "none",
          },
          body: {
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            padding: 0,
          },
        }}
        title={<Text className="text-[18px] font-medium leading-[28px] text-[#101828]">対象選択</Text>}
      >
        <div className="custom-scrollbar mt-4 flex min-h-0 flex-1 flex-col overflow-y-auto" ref={scrollContainerRef}>
          {searchResults.length > 0 ? (
            <BuildingSearchResults
              containerRef={scrollContainerRef}
              loadingMore={loadingMore}
              onBuildingClick={handleBuildingClick}
              onDragStart={() => {
                // Not used in delete mode
              }}
              onLoadMore={onLoadMore}
              results={searchResults}
              selectedBuildingId={selectedTarget?.building_id}
            />
          ) : hasSearched ? (
            <div className="flex h-full flex-col items-center justify-center">
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
          ) : (
            <div className="flex h-full items-center justify-center">
              <Text className="text-[18px] font-normal leading-[20px] text-[#00000040]">検索結果はここに表示</Text>
            </div>
          )}
        </div>
      </Card>

      <Card
        className="flex h-full min-h-0 flex-1 flex-col"
        styles={{
          header: {
            borderBottom: "none",
          },
          body: {
            flex: 1,
            minHeight: 0,
            overflow: "auto",
          },
        }}
        title={<Text className="text-[18px] font-medium leading-[28px] text-[#101828]">登録情報を削除</Text>}
      >
        <DeleteRegistrationPanel
          onRefresh={onRefresh}
          onSearchResultsChange={onSearchResultsChange}
          onSelectedTargetChange={onSelectedTargetChange}
          searchResults={searchResults}
          selectedTarget={selectedTarget}
        />
      </Card>
    </div>
  );
};
